import { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import client from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Mail } from "lucide-react";

const localizedValue = (obj) =>
  (obj && (obj["de-DE"] || Object.values(obj)[0])) || "";

/** Fixed-German mailto template — this isn't tied to the admin UI's EN/DE
 * toggle, it's the actual message sent to Skoda staff on the dealer's
 * behalf, so it stays in German regardless of the viewer's language. */
function buildMailto(dealer, branch, recipientEmail, ccEmail) {
  const dealerCode = dealer.global_id || "";
  const subject = `Antrag auf Änderung der Händlerdaten - ${dealerCode}`;
  const body = [
    `Der Škoda-Händler mit dem Code ${dealerCode} hat die folgende Änderung seiner Informationen beantragt:`,
    "",
    `NAME: ${dealer.name || ""}`,
    `TELEFON: ${dealer.main_contact?.telephone || ""}`,
    `FAX: ${dealer.main_contact?.fax || ""}`,
    `STRASSE: ${localizedValue(branch?.street)}`,
    `PLZ: ${branch?.zip_code || ""}`,
    `STADT: ${localizedValue(branch?.city)}`,
    "",
    "Vielen Dank,",
    "[Your Full Name]",
  ].join("\n");
  const to = encodeURIComponent(recipientEmail || "");
  const params = [`subject=${encodeURIComponent(subject)}`, `body=${encodeURIComponent(body)}`];
  if (ccEmail) params.push(`cc=${encodeURIComponent(ccEmail)}`);
  return `mailto:${to}?${params.join("&")}`;
}

export function MainDataChangeCard({ dealer, branch }) {
  const { t } = useI18n();
  const [recipientEmail, setRecipientEmail] = useState("");
  const [ccEmail, setCcEmail] = useState("");

  useEffect(() => {
    let ignore = false;
    client.get("/settings/data_change_request_email").then(({ data }) => {
      if (!ignore) setRecipientEmail(data.value || "");
    }).catch(() => {});
    client.get("/settings/data_change_request_cc_email").then(({ data }) => {
      if (!ignore) setCcEmail(data.value || "");
    }).catch(() => {});
    return () => { ignore = true; };
  }, []);

  return (
    <Card className="mb-6 p-6" data-testid="main-data-change-card">
      <h2 className="mb-2 text-lg font-semibold">{t("dealership.mainDataChange.title")}</h2>
      <p className="mb-4 text-xs text-muted-foreground">{t("dealership.mainDataChange.hint")}</p>
      <Button asChild variant="outline" size="sm" className="gap-1.5" data-testid="request-data-change-btn">
        <a href={buildMailto(dealer, branch, recipientEmail, ccEmail)}>
          <Mail className="h-3.5 w-3.5" />
          {t("dealership.mainDataChange.button")}
        </a>
      </Button>
    </Card>
  );
}
